import {Component, input} from "@angular/core";
import {AbstractView} from "../../../views/AbstractView";

@Component({
  selector: 'link-progress-bar',
  templateUrl: './progress-bar.view.html',
  styleUrls: ['./progress-bar.view.scss']
})
export class ProgressBarView extends AbstractView<any> {

  loading = input.required<boolean>();
  reserveSpace = input(false);

  constructor() {
    super();
  }
}
